import { render, staticRenderFns } from "./GlassTypeTile.vue?vue&type=template&id=79be10c2&scoped=true&"
import script from "./GlassTypeTile.vue?vue&type=script&lang=ts&"
export * from "./GlassTypeTile.vue?vue&type=script&lang=ts&"
import style0 from "./GlassTypeTile.vue?vue&type=style&index=0&id=79be10c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79be10c2",
  null
  
)

export default component.exports